import { useDispatch, useSelector } from 'react-redux'

import { rejectAddBillingContact } from '../../actions/index'
import ConfirmationDialog from '../ReusableComponents/ConfirmationDialog/index'

const BillingContactDialog = () => {
  const { shouldAskAddBillingContact } = useSelector(s => s.login)
  const dispatch = useDispatch()

  return (
    <>
      {shouldAskAddBillingContact &&
      !['userPermissions', 'addUser', 'login', 'selectHotel'].some(p =>
        document.location.href.includes(p)
      ) ? (
        <ConfirmationDialog
          title="Missing billing contact"
          positiveMessage="Add a billing contact"
          negativeMessage="Add later"
          onClose={() => dispatch(rejectAddBillingContact())}
          onConfirm={() => (document.location.href = '/userPermissions')}
        >
          <p>
            We need at least one billing contact to send invoices at the end of billing
            cycles.
          </p>
        </ConfirmationDialog>
      ) : null}
    </>
  )
}

export default BillingContactDialog
